// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.2.0 (commit eb11e2f5c41dce6979715ad407996270d61329f6).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import CancelStarsRefundReducer from "./cancel_stars_refund_reducer";
import CommitMoveReducer from "./commit_move_reducer";
import ForfeitMatchReducer from "./forfeit_match_reducer";
import JoinQueueReducer from "./join_queue_reducer";
import LeaveQueueReducer from "./leave_queue_reducer";
import NextRoundReducer from "./next_round_reducer";
import RecordStarsPaymentReducer from "./record_stars_payment_reducer";
import RecordStarsRefundReducer from "./record_stars_refund_reducer";
import ReserveStarsRefundReducer from "./reserve_stars_refund_reducer";
import RevealMoveReducer from "./reveal_move_reducer";
import SetProfileReducer from "./set_profile_reducer";
import SubmitMoveReducer from "./submit_move_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AccountRow from "./account_table";
import GameEventRow from "./game_event_table";
import MatchStateRow from "./match_state_table";
import PlayerRow from "./player_table";
import QueueEntryRow from "./queue_entry_table";
import RoundResultRow from "./round_result_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  account: __table({
    name: 'account',
    indexes: [
      { accessor: 'id', name: 'account_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'account_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AccountRow),
  gameEvent: __table({
    name: 'game_event',
    indexes: [
      { accessor: 'id', name: 'game_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'game_event_match_id', name: 'game_event_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'game_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GameEventRow),
  matchState: __table({
    name: 'match_state',
    indexes: [
      { accessor: 'id', name: 'match_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'match_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchStateRow),
  player: __table({
    name: 'player',
    indexes: [
      { accessor: 'identity', name: 'player_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerRow),
  queueEntry: __table({
    name: 'queue_entry',
    indexes: [
      { accessor: 'identity', name: 'queue_entry_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'queue_entry_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, QueueEntryRow),
  roundResult: __table({
    name: 'round_result',
    indexes: [
      { accessor: 'id', name: 'round_result_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'round_result_match_id', name: 'round_result_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'round_result_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RoundResultRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("cancel_stars_refund", CancelStarsRefundReducer),
  __reducerSchema("commit_move", CommitMoveReducer),
  __reducerSchema("forfeit_match", ForfeitMatchReducer),
  __reducerSchema("join_queue", JoinQueueReducer),
  __reducerSchema("leave_queue", LeaveQueueReducer),
  __reducerSchema("next_round", NextRoundReducer),
  __reducerSchema("record_stars_payment", RecordStarsPaymentReducer),
  __reducerSchema("record_stars_refund", RecordStarsRefundReducer),
  __reducerSchema("reserve_stars_refund", ReserveStarsRefundReducer),
  __reducerSchema("reveal_move", RevealMoveReducer),
  __reducerSchema("set_profile", SetProfileReducer),
  __reducerSchema("submit_move", SubmitMoveReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.2.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

